import { useNavigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react'
import CandidateHeader from '@/components/common/CandidateHeader'
import { CandidateSkillsProvider } from '@/contexts/CandidateSkillsContext'
import { BUILD_VERSION } from '@/utils/buildVersion'

export default function CandidateLayout({ children }: { children?: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [currentUser, setCurrentUser] = useState<any>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuthentication = () => {
      // Add a small delay to ensure localStorage is available in static exports
      setTimeout(() => {
        const token = localStorage.getItem('token')
        const userData = localStorage.getItem('currentUser')
        
        if (token && userData) {
          try {
            const user = JSON.parse(userData)
            setCurrentUser(user)
            setIsAuthenticated(true)
            setIsLoading(false)
          } catch (error) {
            console.error('Error parsing user data:', error)
            setIsLoading(false)
            const currentPath = window.location.pathname + window.location.search
            const loginUrl = `/login?returnUrl=${encodeURIComponent(currentPath)}`
            navigate(loginUrl)
          }
        } else {
          setIsLoading(false)
          const currentPath = window.location.pathname + window.location.search
          const loginUrl = `/login?returnUrl=${encodeURIComponent(currentPath)}`
          navigate(loginUrl)
        }
      }, 100)
    }

    // Only run auth check on client side
    if (typeof window !== 'undefined') {
      checkAuthentication()
    }
  }, [navigate])

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    )
  }

  // Don't render anything if not authenticated (will redirect to login)
  if (!isAuthenticated) {
    return null
  }

  return (
    <CandidateSkillsProvider>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <CandidateHeader />
        
        <main className="py-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex-1 w-full">
          {children || <Outlet />}
        </main>

        <footer className="border-t border-gray-200 bg-white py-3 text-center text-xs text-gray-500">
          Build {BUILD_VERSION}
        </footer>
      </div>
    </CandidateSkillsProvider>
  )
}
